export const FETCH_USER = 'getUser';
export const CLEAR_USER = 'clearUser';
